// src/locales/en.settings.ts
const settings = {  

//Help and Support for later please

//StartSetting
settingsOverview: {
  title: 'Settings overview',
  subtitle:
    'Manage your Elnydo account, privacy, security and profile tools from one central place.',

  cards: {
    account: {
      title: 'Account Settings',
      pill: 'Basics',
      desc:
        'Update email and password, choose your app language and pause your profile visibility.',
      item1: 'Change email',
      item2: 'Change password',
      item3: 'Language & localization',
      item4: 'Pause public profile',
      cta: 'Open Account settings',
    },

    privacy: {
      title: 'Data & Privacy',
      pill: 'Important',
      desc:
        'Control location access, push notifications, anonymous analytics and manage your stored data.',
      item1: 'Allow or disable location fetching',
      item2: 'Push notification preferences',
      item3: 'Anonymous analytics opt-in/out',
      item4: 'View all stored data',
      item5: 'Privacy policy & account deletion',
      cta: 'Open Data & privacy',
    },

    security: {
      title: 'Security',
      pill: 'Protection',
      desc:
        'Add extra protection with 2-factor authentication and manage active logins across devices.',
      item1: 'Enable / manage 2-factor authentication',
      item2: 'See your 2FA recovery codes',
      item3: 'Log out from all devices',
      cta: 'Open Security settings',
    },

    profileMgmt: {
      title: 'Profile Management',
      pill: 'Activity',
      desc:
        'See posts, followers and following, review notifications and manage your blocked users.',
      item1: 'See your own postings',
      item2: 'Notifications overview',
      item3: 'Followers & following lists',
      item4: 'Blocked users management',
      cta: 'Open Profile management',
    },

    help: {
      title: 'Help & Support',
      pill: 'Support',
      desc:
        'Contact the Elnydo team if you need help, want to report a problem or give feedback.',
      item1: 'Contact Elnydo support',
      item2: 'Report issues or abuse',
      item3: 'Send feedback & ideas',
      cta: 'Open Help & support',
    },

    policies: {
  title: "Policies",
  pill: "Legal",

  desc:
    "Learn how Elnydo operates, how your data is handled, and the rules that apply when using the platform.",

  item1: "Read our Privacy Policy",
  item2: "Review the Terms of Use",

  privacyCta: "Privacy Policy",
  termsCta: "Terms of Use",
},
  },
},

//SecuritySettings
securitySettings: {
  page: {
    title: 'Security',
    subtitle: 'Manage two-factor authentication and active sessions.',
  },

  loadError: {
    unauthenticated: 'You are not authenticated. Please sign in again.',
    statusLoadFallback: 'Could not load 2FA status.',
  },

  twoFA: {
    sectionTitle: 'Two-Factor Authentication (Email)',
    statusLabel: 'Status:',
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    manageButton: 'Manage 2FA (Email)',
    disableButton: 'Disable 2FA',
    loading: 'Loading security status…',
    enableHint: 'Click “Manage 2FA (Email)” to enable — password → email → OTP.',

    alerts: {
      disableMissingPassword: 'Enter your password to disable 2FA.',
      disableSuccess: '2FA disabled.',
      disableError: 'Failed to disable 2FA.',
      logoutAllConfirm: 'Sign out from all devices?',
      logoutAllSuccess: '✅ All sessions revoked. Please sign in again.',
      logoutAllError: 'Failed to revoke sessions.',
    },
  },

  twoFAWizard: {
    modalTitle: 'Enable 2FA (Email)',

    errors: {
      missingPassword: 'Please enter your current password.',
      missingEmails: 'Please enter and confirm your email.',
      emailMismatch: 'Emails do not match.',
      invalidEmail: 'Please enter a valid email address.',
      sendFailed: 'Failed to send verification code.',
      unauthenticatedSuffix: '(Unauthenticated — is your token stored?)',
      missingOtp: 'Enter the 6-digit code we sent.',
      verifyFailed: 'Verification failed.',
    },

    steps: {
      passwordTitle: 'Step 1 — Confirm your password',
      passwordPlaceholder: 'Current password',

      emailTitle: 'Step 2 — Choose the email address for your 2FA codes',
      emailPlaceholder: 'you@example.com',
      emailConfirmPlaceholder: 'Confirm email',
      emailTip:
        'Tip: You can keep your account email if you don’t want a separate address.',

      otpTitlePrefix: 'Step 3 — Enter the 6-digit code we sent to',

      otpPlaceholder: '123456',

      doneMessage: '✅ 2FA is now enabled.',
    },

    buttons: {
      cancel: 'Cancel',
      continue: 'Continue',
      back: 'Back',
      sendCodeIdle: 'Send code',
      sendCodeBusy: 'Sending…',
      verifyEnableIdle: 'Verify & Enable',
      verifyEnableBusy: 'Verifying…',
      close: 'Close',
    },
  },

  recoveryCodes: {
    sectionTitle: 'Save your recovery codes',
    description:
      'Store these codes safely. They can be used if you lose access to your email.',
    fileHeader: 'Your recovery codes (store securely)',
    fileGeneratedLabel: 'Generated:',
    downloadButton: 'Download .txt',
    copyButton: 'Copy to Clipboard',
    dismissButton: 'Dismiss',
    copySuccess: 'Copied to clipboard.',
    copyError: 'Copy failed.',
  },

  sessions: {
    sectionTitle: 'Active Sessions',
    description: 'Revoke every signed-in device. You’ll need to sign in again here.',
    buttonIdle: '🔒 Logout from All Devices',
    buttonBusy: 'Revoking…',
  },

  disableModal: {
    title: 'Disable 2FA',
    description: 'Enter your password to disable 2FA.',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    cancelButton: 'Cancel',
    confirmButtonIdle: 'Confirm Disable',
    confirmButtonBusy: 'Disabling…',
  },
},

// ProfileManagement
profileManagement: {
  page: {
    title: 'Profile Management',
    subtitle: 'Manage your profile, posts, followers, favorites, and blocked users.',
  },
  buttons: {
    profile: 'My Profile',
    postings: 'My Postings',
    notifications: 'Notifications',
    favorites: 'My Favorites',
    followers: 'Followers',
    blocked: 'Blocked Users',
  },
},

//Data Privacy
  dataPrivacy: {
    page: {
      title: 'Data & Privacy',
      subtitle: 'Control optional processing, export your data, or delete your account.',
    },

    intro: {
      mainText:
        'Some processing is essential to provide the service (e.g., account, security, abuse prevention) and is based on Contract or Legitimate Interests. Other processing below uses your Consent and is optional.',
      legalSeeOur: 'See our',
      and: 'and',
      privacyLinkLabel: 'Privacy Policy',
      subprocessorsLinkLabel: 'Subprocessors',
    },

    essential: {
      title: 'Essential processing (required)',
      description:
        'Account, security, service integrity, and non-personalized operations. This cannot be disabled.',
      badgeLabel: 'Required',
    },

    optional: {
      sectionTitle: 'Optional processing',
      loading: 'Loading My Feed…',
      saving: 'Saving…',
      lastSaved: 'Last saved: {{timestamp}}',

      toggles: {
        yes: 'Yes',
        no: 'No',

        analyticsTitle: 'Anonymous analytics',
        analyticsDescription:
          'Helps us understand feature usage in aggregate. No third-party ad trackers.',

        pushTitle: 'Push notifications',
        pushDescription:
          'Receive app notifications for messages and activity. Your OS settings also apply.',

        locationTitle: 'Device location for features',
        locationDescription:
          'Used to tag posts with city/country and show nearby content. You can revoke in device settings.',
      },

      alerts: {
        saveError: '❌ Failed to save preferences.',
      },
    },

    deletion: {
      sectionTitle: 'Delete Account & All Data',
      warnLine1: 'This permanently deletes your account and all data immediately.',
      warnLine2: 'This cannot be undone.',
      buttonLabel: '🗑️ Delete My Account and Data',

      pwModalTitle: 'Confirm your password',
      pwModalDescription:
        'Please enter your account password. We will email you a 6-digit code. Entering that code here will permanently delete your account and all data.',
      pwPlaceholder: 'Enter your password',
      pwSendCodeIdle: 'Send Code',
      pwSendCodeBusy: 'Sending…',
      pwCancel: 'Cancel',

      otpModalTitle: 'Enter 6-digit code',
      otpModalDescription:
        'By entering this code, your account and all data will be deleted immediately and permanently.',
      otpPlaceholder: '••••••',
      otpDeleteIdle: 'Delete Now',
      otpDeleteBusy: 'Deleting…',
      otpCancel: 'Cancel',

      alerts: {
        missingPassword: 'Please enter your password.',
        startError: 'Could not start deletion.',
        missingOtp: 'Enter the 6-digit code.',
        verifyError: 'Verification failed.',
      },
    },

    export: {
      sectionTitle: 'Your Data Rights',
      description: 'You can export a copy of your data at any time.',
      buttonLabel: '📦 Export My Data',
      alerts: {
        exportError: '❌ Could not export your data.',
      },
    },

    policySection: {
      sectionTitle: 'Privacy Policy',
      description: 'Read the full details on how we process and protect your data.',
      buttonLabel: '📄 View Privacy Policy',
    },
  },

  //Account Settings
    accountSettings: {
      page: {
        title: 'Account Settings',
        subtitle:
          'Manage your profile, email, password, language and profile visibility.',
      },    
  
      profileName: {
        sectionTitle: 'Profile Name',
        sectionDescription: 'Your public profile name. It cannot be changed.',
        label: 'Profile Name (not changeable)',
        shareButton: 'Share in E-Mail',
  
        shareModalTitle: 'Share Profile via E-Mail',
        shareModalDescription:
          "Enter the recipient's email. We’ll open your mail app with a prefilled message.",
        shareRecipientLabel: 'Recipient email',
        shareRecipientPlaceholder: 'recipient@example.com',
        shareCancel: 'Cancel',
        shareSubmit: 'Share',
        shareSubmitting: 'Opening…',
        shareInvalidEmail: 'Please enter a valid email address.',
  
        mailSubject: "Check out {{name}}'s profile",
        mailBody:
          "Hi,\n\nHere is my profile:\n\nName: {{name}}\nOpen profile: {{link}}\n\n",
      },
  
      emailChange: {
        sectionTitle: 'Change E-Mail',
        sectionDescription:
          'Start an email change and confirm it with a 6-digit code sent to your new address.',
        currentEmail: 'Current E-Mail',
        newEmail: 'New E-Mail',
        missingNewEmail: 'Please enter your new email.',
  
        validationInvalid: 'Enter a valid email.',
        validationSame: 'New email must be different from current.',
        startButton: 'Change E-Mail',
        startButtonLoading: 'Starting…',
  
        startSuccess:
          '✅ We sent a 6-digit code to your NEW email. We also notified your old email.',
  
        otpModalTitle: 'Verify New E-Mail',
        otpModalDescription: 'Enter the 6-digit code we sent to {{email}}.',
        otpLabel: 'Verification code',
        fallbackEmail: 'your new email',
  
        otpCancel: 'Cancel',
        otpResend: 'Resend',
        otpResending: 'Resending…',
        otpVerify: 'Verify',
        otpVerifying: 'Verifying…',
  
        otpMissing: 'Please enter the 6-digit code.',
        otpSuccess: '✅ Email updated.',
        otpError: '❌ Verification failed.',
        otpResendSuccess: 'A new code was sent.',
        otpResendError: 'Could not resend code.',

        passwordconfirmpassword: 'Enter your current password to continue.',
        currentpassword: 'Current password',
      },
  
      password: {
        sectionTitle: 'Change Password',
        sectionDescription:
          'Update your password in a two-step flow (current → new).',
        sectionButton: 'Change password…',
  
        alerts: {
          missingCurrentFields: 'Please enter your current password.',
          success: '✅ Password updated.',
          error: '❌ Failed to update password.',
          currentIncorrect: 'Current password is incorrect.',
        },
      },
  
      passwordFlow: {
        titleConfirm: "Confirm your Password",
        titleChooseNew: "Choose a New Password",
  
        enterCurrentHint: "Enter your current password to continue.",
        currentLabel: "Current password",
        currentPlaceholder: "Current password",
  
        policyHint: "Use at least 8 characters and include a number.",
        newLabel: "New password",
        newPlaceholder: "At least 8 characters, incl. a number",
  
        confirmLabel: "Confirm new password",
        confirmPlaceholder: "Repeat new password",
  
        chipOk: "✓",
        chipBad: "✕",
        chipLen: "8+ characters",
        chipDigit: "at least 1 number",
        chipMatch: "passwords match",
  
        updating: "Updating…",
        updatePassword: "Update Password",

        successTitle: "Password updated",
        successBody: "Your password has been changed successfully.",
        done: "Done",

      },
      
      pauseProfile: {       
        deactivateModalTitle: 'Confirm Deactivation',
        deactivateModalDescription:
          'Enter your current password to deactivate your profile. You can reactivate at any time.',
        deactivateModalLabel: 'Current password',
  
        modalCancel: 'Cancel',
        modalDeactivating: 'Deactivating…',
        modalDeactivate: 'Deactivate',
        statusDeactivated: "Your profile is currently deactivated",
        statusActive: "Your profile is active.",
        since: " (since {{date}})",
        deactivateButton: "Deactivate Profile...",
        reactivateButton: 'Reactivate Profile...',
        reactivating: "Reactivating...",
        alerts: {
          missingPassword: 'Please enter your current password.',
          deactivatedSuccess: '✅ Account deactivated.',
          deactivatedError: '❌ Failed to deactivate.',
          reactivatedSuccess: '✅ Account reactivated.',
          reactivatedError: '❌ Failed to reactivate.',
        },

        reactivateConfirm: {
          title: "Reactivate profile",
          body: "Are you sure you want to reactivate your profile?",
          yesBusy: "Reactivating...",
          error: "Failed to reactivate profile. Please try again.", 
        }
    },
    
  
      pageAlerts: {
        saveSuccess: '✅ Account settings saved!',
        saveError: '❌ Failed to save settings',
      },

      language: {
        sectionTitle: 'Language',
        sectionDescription: 'Choose your preferred language for the app interface.',
        saveButtonIdle: 'Save language',
        saveButtonLoading: 'Saving…',
        pauseprofile: 'Deactivate Profile',
        pausedescr: 'Temporarily hide your profile. You can reactivate it at any time.',
  
        alerts: {
          success: '✅ Language saved!',
          error: '❌ Failed to save language.',
        },
  
        // Display names in their *own* language
        options: {
          en: 'English',
          de: 'Deutsch',
          fr: 'Français',
          es: 'Español',
          pt: 'Português',
          nl: 'Nederlands',
          it: 'Italiano',
          pl: 'Polski',
  
          hu: 'Magyar',
          cs: 'Čeština',
          ru: 'Русский',
          uk: 'Українська',
  
          ja: '日本語',
          ko: '한국어',
          ar: 'العربية',
          vi: 'Tiếng Việt',
  
          // Some extra common ones – optional, remove if you don’t need them:
          tr: 'Türkçe',
          zh: '中文',
        },

        
      },
    },
  } as const;
  
  export default settings;
  